import { Component, OnInit, ElementRef, ViewChild, NgZone, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { MapsAPILoader } from '@agm/core';
import { RsbService } from 'src/app/service/rsb.service';
import { Router } from '@angular/router';



@Component({
  selector: 'app-my-projects',
  templateUrl: './my-projects.component.html',
  styleUrls: ['./my-projects.component.css']
})
export class MyProjectsComponent implements OnInit {
  allListings: Array<any> = [
    {
      projectId: 'PRJ-101',
      projectName: 'Pillar Heights',
      createdAt: '2026-08-15T10:00:00'
    },
    {
      projectId: 'PRJ-102',
      projectName: 'The Grand Avenue',
      createdAt: '2026-08-22T10:00:00'
    },
    {
      projectId: 'PRJ-103',
      projectName: 'Lakeview Residency',
      createdAt: '2026-09-02T10:00:00'
    },
    {
      projectId: 'PRJ-104',
      projectName: 'Green Valley Homes',
      createdAt: '2026-09-04T10:00:00'
    },
    {
      projectId: 'PRJ-105',
      projectName: 'Metro Plaza',
      createdAt: '2026-09-05T10:00:00'
    },
    {
      projectId: 'PRJ-106',
      projectName: 'Palm Enclave',
      createdAt: '2026-09-06T10:00:00'
    },
    {
      projectId: 'PRJ-107',
      projectName: 'City Walk',
      createdAt: '2026-09-07T10:00:00'
    },
    {
      projectId: 'PRJ-108',
      projectName: 'Sunrise Towers',
      createdAt: '2026-09-08T10:00:00'
    },
    {
      projectId: 'PRJ-109',
      projectName: 'Silver Park',
      createdAt: '2026-09-09T10:00:00'
    },
    {
      projectId: 'PRJ-110',
      projectName: 'Urban Nest',
      createdAt: '2026-09-10T10:00:00'
    }
  ];
  constructor(
    private lookupModel: RsbLookupModel,
    private rsbService: RsbService,
    private route:Router
  ) { }

  ngOnInit(): void {
  }
  addRouteUnit(listings){
    this.lookupModel.setVendorProperty(listings);
    this.route.navigate(['unit'])
  }

  getAllListings(): void {
    this.rsbService.getAllProjectListings(1).subscribe((rsp) => {
      if(rsp.statusCode === 0 && rsp.contents.length) {
        this.allListings = rsp.contents
      } else {
        this.allListings = []
      }
    })
  }
}
